<template>
  <el-upload 
    class="file-uploader-wrapper" 
    ref="videoUpload" name="file" 
    :accept="accept" 
    :multiple="false" 
    :action="uploadParams.host" 
    :on-change="onChange" 
    :data="uploadData" 
    :show-file-list="false" :on-success="onFileSuccess" :on-error="onFileError" :on-progress="onProgress" :before-upload="beforeUpload" :auto-upload="false">
    <slot>
      <span v-show="!progressShow">
        <div title="点击更改" class="upload-preview-box" v-if="localVideoUrl" :style="{backgroundImage: `url('${localVideoUrl}?x-oss-process=video/snapshot,t_1000,m_fast')`}">
          <i class="el-icon-circle-close" @click.stop.prevent="removeVideo"></i>
        </div>
        <i title="点击上传" v-else class="el-icon-plus file-uploader-icon"><span>上传视频</span></i>
      </span>
      <el-row v-show="progressShow" class="progress-el">
        <el-progress type="circle" class="progress" :percentage="percentage" :width="50"></el-progress>
      </el-row>
      <div slot="tip" class="el-upload__tip" v-html="tip" v-if="tip"></div>
    </slot>
  </el-upload>
</template>

<style lang="scss">
.file-uploader-wrapper {
  font-size: 0px;
  .el-upload {
    width: 120px !important;
    height: 120px !important;
    display: flex;
    margin-right: 10px;
    overflow: initial !important;
    position: relative;
    .progress-el {
      position: absolute;
      top: 28px;
      left: 35px;
      .progress {
        width: 50px;
        height: 50px;
        background-color: transparent;
      }
    }
  }
  .el-upload__tip {
    display: inline-block;
    line-height: 24px;
    font-size: 14px;
    color: #c5c5c5;
    vertical-align: bottom;
  }
}

.file-uploader-icon {
  font-size: 14px;
  width: 120px;
  height: 120px !important;
  line-height: 120px !important;
}

.upload-preview-box {
  width: 118px !important;
  height: 118px !important;
  position: relative;
  .el-icon-circle-close {
    position: absolute;
    right: -8px;
    top: -8px;
    font-size: 20px;
    background: #ffffff;
    cursor: pointer;
    border-radius: 50%;
  }
}
</style>

<script>
import util from '@/js/util'
import upFile from '../views/picture/assets/scripts/upFile'
export default {
  props: ["videoUrl", "tip", "currentIndex", "defaultImg"],
  data() {
    return {
      imgSrc: null,                                         // 图片URL
      percentage: 0,                                        // 当前上传进度
      progressShow: false,                                  // 上传进度是否显示
      accept: 'video/mp4, video/mov, video/m4v, video/3gp, video/avi, video/m3u8, video/webm',                                  // 文件格式
      uploadParams: {                                       // 上传参数
        host: ''
      },
      localVideoUrl: this.videoUrl
    };
  },
  watch: {
    videoUrl(newVal) {
      this.localVideoUrl = newVal;
    }
  },
  created() {
  },
  mounted() {
    this.percentage = 50;
  },
  computed: {
    uploadData() {
      return {
        policy: this.uploadParams.policy,
        signature: this.uploadParams.signature,
        OSSAccessKeyId: this.uploadParams.access_id,
        success_action_status: '200',
        name: this.filename,
        key: this.filename,
      }
    }
  },
  watch: {
    uploadedImg(val) {
      this.imgSrc = val;
    }
  },

  methods: {
    // 上传前回调
    beforeUpload() {
      this.progressShow = true;
    },
    // 视频选中回调
    async onChange(res) {
      if (res.status === 'ready') {
        let imgSrc =  await upFile(lib.api,'ec/c/tool/upload/auth/get',res);
        this.localVideoUrl = imgSrc;
        this.$emit("uploaded", imgSrc);
      }
    },
    // 视频上传成功
    onFileSuccess(res, file, fileList) {
      console.log('视频上传成功=>', res);
      this.localVideoUrl = `${this.uploadParams.host}/${this.filename}`;
      this.percentage = 100;
      this.progressShow = false;
      this.$emit("uploaded", this.localVideoUrl);
    },
    // 视频上传失败
    onFileError() {
      this.percentage = 0;
      this.progressShow = false;
    },
    // 视频上传进度
    onProgress(res) {
      this.percentage = res.percent
    },
    // 移除视频
    removeVideo() {
      this.localVideoUrl =null;
    }
  }
};
</script>
